import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React from "react";

import SectionWrapper from "../../section-wrapper";
import useHolidaysSection from "./controller/use-holidays-section";
import HolidayFormDialog from "./ui/components/holiday-form-dialog";
import HolidaysTable from "./ui/components/holidays-table";

interface HolidaysSectionProps {
	companyId: number;
	companyName: string;
	// Set for the Location-level section; omitted for the Company-level one
	locationId?: number;
	locationName?: string;
}

const HolidaysSection = ({
	companyId,
	companyName,
	locationId,
	locationName,
}: HolidaysSectionProps) => {
	const [
		{
			t,
			scope,
			holidays,
			holidayTypes,
			isLoading,
			canManageCompanyHolidays,
			canAddHoliday,
			dialog,
			isSubmitting,
			snackbar,
		},
		{
			handleOpenAdd,
			handleOpenEdit,
			handleCloseDialog,
			handleSubmit,
			handleRemove,
			handleCloseSnackbar,
		},
	] = useHolidaysSection({ companyId, companyName, locationId, locationName });

	return (
		<SectionWrapper
			title={t("holidays_section-title")}
			subtitle={
				scope === "company"
					? t("holidays_section-subtitle-company")
					: t("holidays_section-subtitle-location", { location: locationName })
			}
		>
			<HolidaysTable
				scope={scope}
				title={
					scope === "company"
						? t("holidays_table-title-company")
						: t("holidays_table-title-location", { location: locationName })
				}
				holidays={holidays}
				isLoading={isLoading}
				locationName={locationName}
				canAddHoliday={canAddHoliday}
				canManageCompanyHolidays={canManageCompanyHolidays}
				onAdd={handleOpenAdd}
				onEdit={handleOpenEdit}
				onRemove={handleRemove}
			/>
			<HolidayFormDialog
				open={dialog.open}
				mode={dialog.mode}
				scope={scope}
				initialData={dialog.initialData}
				holidayTypes={holidayTypes}
				companyName={companyName}
				locationName={locationName}
				isSubmitting={isSubmitting}
				onClose={handleCloseDialog}
				onSubmit={handleSubmit}
			/>
			<Snackbar
				open={snackbar !== null}
				autoHideDuration={3000}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<MuiAlert
					elevation={6}
					variant="filled"
					severity={snackbar?.severity ?? "success"}
					onClose={handleCloseSnackbar}
				>
					{snackbar?.message}
				</MuiAlert>
			</Snackbar>
		</SectionWrapper>
	);
};

export default HolidaysSection;
